import { empSelectWidget } from './all';
import { SECTION_ID as mprExecSumSectionId } from './mprExecutiveSummary';
import { SECTION_ID as baseExecSumSection } from './baseExecutiveSummary';

export const toggleApprovalLoading = function (role, action) {
    let $approvalBtn = $('#mprExecSumApprovalBtn_' + role), $loadingBar = $('#loading_' + role);
    switch (action) {
        case 'hide' : {
            $approvalBtn.show();
            $loadingBar.hide();
            break;
        }
        case 'show' : {
            $approvalBtn.hide();
            $loadingBar.show();
            break;
        }
        default : {
            $approvalBtn.toggle();
            $loadingBar.toggle();
        }
    }
};

export const toggleRejectLoading = function (action) {
    let $rejectBtn = $('#resetApprovalBtn'), $loadingBar = $('#loading_resetApprovalBtn');
    switch (action) {
        case 'hide' : {
            $rejectBtn.show();
            $loadingBar.hide();
            break;
        }
        case 'show' : {
            $rejectBtn.hide();
            $loadingBar.show();
            break;
        }
        default : {
            $rejectBtn.toggle();
            $loadingBar.toggle();
        }
    }
};

export const saveApproval = function (role) {
    event != null && event.preventDefault();

    return new Promise((resolve, reject) => {
        // showApprovalLoadingBar(role);
        toggleApprovalLoading(role);
        let $userInput = $('#prMprExecSumApprovalEmp_' + role), $pinInput = $('#prMprExecSumApprovalPin_' + role), data = {
            pid: parseInt($('#Project_Pid').val()), mid: $('#Id').val() || -1, empNum: parseInt($userInput.val() || 0), pin: $pinInput.val() || 'invalid', role: role
        };

        $pinInput.removeClass('is-invalid');
        $userInput.removeClass('is-invalid');

        $.post('/Forms/ProjectReview/SubmitApproval', data, function (response) {
            toggleApprovalLoading(role);
            if (response === 'Incorrect Pin') {
                kendo._l.showErrorNotification('Incorrect/Invalid Pin Provided');
                // alert('Incorrect/Invalid Pin Provided');
                $pinInput.addClass('is-invalid');
                reject('Incorrect/Invalid Pin Provided');
            } else if (response === 'Not Permitted') {
                kendo._l.showErrorNotification('Selected team member does not have approval permission.');
                // alert('Selected team member does not have approval permission.');
                $userInput.addClass('is-invalid');
                reject('Selected team member does not have approval permission.');
            } else if (response === 'User has already approved form') {
                kendo._l.showErrorNotification('User has already approved form');
                reject('User has already approved form');
            } else {
                resolve();
            }
        })
            .fail(function (e) {
                // Post Failed; User does not have a pin setup
                // Output error
                // Show Error Notification
                kendo._l.showErrorNotification('Failed to submit approval. Please ensure your pin is set');
                // Hide Loading Bar
                toggleApprovalLoading(role);

                reject('Failed to submit approval. Please ensure your pin is set');
            });
    });
};

export const rejectApprovals = function (section, data) {
    toggleRejectLoading();
    data.pid = parseInt($('#Project_Pid').val());
    data.mid = $('#Id').val() || -1;
    return new Promise((resolve, reject) => {
        let rejectUrl = '/Forms/ProjectReview/';

        switch (section) {
            case mprExecSumSectionId: {
                rejectUrl += 'RemoveMprExecSumApprovals';
                break;
            }
            case baseExecSumSection : {
                rejectUrl += 'RemoveBaseExecSumApprovals';
                break;
            }
        }
        $.post(rejectUrl, data, function (response) {
            $('#approvalRemovalPopup').data('kendoWindow').close();
            if (response === 'Failed') {
                //Remove Approval Failed
                kendo._l.showErrorNotification('Failed to Reject/Reset Approvals');
                toggleRejectLoading();
                reject('Failed to Reject/Reset Approvals');
            } else {
                resolve();
            }
        }).fail(function (e) {
            //Remove Approval Failed
            console.debug(e);
            // Remove Loading Bar
            toggleRejectLoading();
            kendo._l.showErrorNotification('Failed to Reject/Reset Approvals');
            reject('Failed to Reject/Reset Approvals');
        });
    });
};

export const loadApprovals = function() {
    return new Promise((resolve, reject) => {
        if ($('[id*=mprExecSumApprovalBtn_]').length <= 0) {
            //No More approvals required; Remove reject button
            $('#rejectButtonSection').remove();
        }
        empSelectWidget();
        resolve();
    });
};
